<template>
<b-row class="ot-main-panel no-gutters">
    <b-col>
        <template v-if="loaded === false">
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
        <template>
            <EventModel v-model="showEventModal" ref="eventModal" />
        </template>
         <b-row>
            <b-col>
                <b-row  class=" no-gutters OT-content-header">
                    <b-col cols="3">
                        <b-nav>
                            <b-nav-item @click.prevent="toggleFilters()">
                                <otif-icon :icon="filterGlobalAction.name" :label="filterGlobalAction.label"/>
                            </b-nav-item>
                        </b-nav>
                    </b-col>
                    <b-col class="OT-table-title">
                       <select-dashboard :selectedFacet="selected"/>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row class="no-gutters">
            <b-col cols="3" v-if="showFilters" class="ot-table-filters  OT-LeftPanel OTfacetsgroup">
                <Filters/>
            </b-col>
            <b-col>
                <b-col>
                <events></events>
                </b-col>
            </b-col>
        </b-row>
    </b-col>
</b-row>

</template>

<script>

import axios from 'axios';
import moment from 'moment';
import Filters from './eventfilters/Filters.vue';
import SelectDashboard from './SelectDashboard.vue'
import EventModel from './events/EventModel.vue';
import Events from './Events.vue'


export default {

    props: [
        'isRoute'
    ],

    data() {
        return {
            default:"Event Dashboard",
            loaded : true,
            showEventModal : false,
            showFilters : true,
            sidePanel: true,
            socketTimer: null,
            filterGlobalAction: {
                name: 'filter',
                label: 'Filters',
                callback: this.toggleFilters
            },
            columns: [{
                    name: 'Level',
                    label: 'level'
                },{
                    name: 'Events',
                    label: 'events'
                },{
                    name: 'Date',
                    label: 'date'
                },{
                    name: 'Services',
                    label: 'services'
                },{
                    name: 'Project',
                    label: 'project'
                },{
                    name: 'Job',
                    label: 'job'
                },{
                    name: 'Content Sources',
                    label: 'content sources'
                }
            ]        
        }
    },

    computed: {

        information(){
            return "Event Information"
        },
        
        connected() {
            return this.$store.state.socket.connected;
        },
        
        debug() {
            return process.env.NODE_ENV === 'development';
        },

        selected(){
            return "Event Dashboard"
        },
    },
    
    methods:{
        
        toggleFilters() {
            if (this.showFilters === true) {
                this.showFilters = false;
            } else {
                this.showFilters = true;
            }
        },

        onLoggedIn: function() {
            this.$store.commit('LOGGED_IN');
        },

        subscribe() {
            this.$socket.sendObj({
                subscribe: ['eventFacets','events']
            });
        },

        defaultFacet() {
            if(this.isRoute && this.isRoute === 'true'){

                var nodes = Object.keys(this.$store.state.facets.selectedFacets).map((facetId) => {
                    return {
                        'type': 'condition',
                        'field': facetId,
                        'in': this.$store.state.facets.selectedFacets[facetId]
                    }
                });
                var facet= {};

                if(nodes.length < 1){

                    // Sending default facet
                    this.$socket.sendObj({
                        'filter': {
                            'queryPointId': "events",
                            'facet':{
                                type  : 'condition',
                                field : 'TF_ID',
                                in    : ['LHD_ID']
                            }
                        }
                    });
                } else {
                    if(nodes.length === 1){
                        facet = nodes[0]
                    } else {
                        facet.type = 'and';
                        facet.nodes = nodes
                    }
                    var cmdMsg = {                        
                        'filter': {
                            'queryPointId': "events",
                            'facet' : facet   
                        }
                    };
                    this.$store.state.components.events = []
                    this.$socket.sendObj(cmdMsg);
                }
                
            } else {
                // Sending default facet
                this.$socket.sendObj({
                    'filter': {
                        'queryPointId': "events",
                        'facet':{
                            type  : 'condition',
                            field : 'TF_ID',
                            in    : ['LHD_ID']
                        }
                    }
                });
            }
        }
    },

    beforeMount() {
        this.$eventBus.$on('event', (event) => {
            this.$refs.eventModal.eventId = event[6]
            this.showEventModal = true;
        });
    },

    mounted() {
        this.$socket.connect();

        if (!this.connected) {
            var connectedInterval = setInterval(() => {
                if (this.connected) {
                    this.subscribe();
                    this.defaultFacet();
                    this.loaded = true;
                    clearInterval(connectedInterval);
                }
            }, 1000);
        } else {
            this.subscribe();
            this.defaultFacet();
            this.loaded = true;
        }
    },

    beforeRouteLeave(to, from, next) {
        this.$socket.sendObj({
            unSubscribe: ['eventFacets','events']
        });
        this.$store.commit('components/CLEAR');
        this.$store.commit('facets/CLEAR');
        if (to.hasOwnProperty('meta') && to.meta['ws'] !== true) {
            this.$socket.disconnect();
        }
        next();
    },

    beforeDestroy() {
        this.$store.state.facets.selectedFacets = {}
        this.$eventBus.$off('event');
    },

    components: {
        Filters,
        SelectDashboard,
        EventModel,
        Events
    }
}

</script>
